/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './workspace-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {WorkspaceApiService, WorkspaceModel} from './workspace-api.service';

@Component({
  standalone: false,
  selector: 'adn-workspace-list-page',
  template
})
export class WorkspaceListPageComponent implements OnInit {
  readonly itemStateName = 'app.wor.workspaces.workspace';

  columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: '', label: 'type', sortable: false}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<WorkspaceModel>(
    inject(WorkspaceApiService),
    {listId: 'workspaceList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
